/**
 * Single source of truth for "which ABHA identity does this registration link?".
 *
 * The only input is `abhaResult` — the manual ABHA verify/create flow (onAbhaComplete). A Scan &
 * Share scan no longer supplies an identity here (R58: the socket carries only a scan_id); it is
 * revealed and claimed by scan_id (POST /abha/scan-share/claim) from the desk-wide waiting panel.
 *
 * Returns null when no usable ABHA identity is present (an ABHA number is required).
 */
export const IDENTITY_SOURCE = Object.freeze({
  MANUAL_ABHA_VERIFY: 'MANUAL_ABHA_VERIFY',
});

export function resolvePatientIdentity(abhaResult) {
  if (!abhaResult || !abhaResult.abhaNumber) return null;
  return {
    source: IDENTITY_SOURCE.MANUAL_ABHA_VERIFY,
    abhaNumber: abhaResult.abhaNumber,
    abhaAddress: abhaResult.abhaAddress || '',
    // Full verified profile from the SAME source as the identity → persisted + enriches demographics.
    profile: abhaResult,
  };
}
